<template>
	<h1 class="font-open-sans text-3xl font-bold tracking-tight text-gray-900">
		<slot />
	</h1>
</template>
